import { Button, ButtonProps } from 'primereact/button';
import { useRef, MouseEvent } from 'react';

export type AppButtonProps = ButtonProps;

const AppButton: React.FC<AppButtonProps> = ({ size, onClick, tooltipOptions, ...props }) => {
  const buttonRef = useRef<Button>(null);

  // Default tooltip options: position top and append to document body
  const defaultTooltipOptions = {
    position: 'top' as const,
    appendTo: () => document.body,
  };

  // Merge user-provided tooltipOptions with defaults
  // User-provided options take precedence
  const mergedTooltipOptions = {
    ...defaultTooltipOptions,
    ...tooltipOptions,
  };

  // Wrap onClick to hide tooltip on click
  const handleClick = (e: MouseEvent<HTMLButtonElement>): void => {
    // Hide tooltip by removing active tooltip elements from DOM
    const tooltipElements = document.querySelectorAll('.p-tooltip');
    tooltipElements.forEach((tooltip) => {
      if (
        tooltip.classList.contains('p-tooltip-active') ||
        (tooltip as HTMLElement).style.display !== 'none'
      ) {
        (tooltip as HTMLElement).style.display = 'none';
        tooltip.classList.remove('p-tooltip-active');
      }
    });

    // Call the original onClick handler if provided
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      ref={buttonRef}
      {...props}
      size={size ?? 'small'}
      tooltipOptions={mergedTooltipOptions}
      onClick={handleClick}
    />
  );
};

export default AppButton;
